import { FORM_ERROR } from 'final-form'
import {
  createValidator,
  ErrorObject,
  maxLength,
  required,
  richTextMaxLength,
  ValidatorFunction,
} from 'util/validation'

import { EncaminhamentoExternoEspecializadoModel } from '../model-encaminhamentoExterno'

export function encaminhamentoExternoFormValidator(
  canAcessoCBORegisterCid10: boolean,
  encaminhamentosRecentes: ReadonlyArray<EncaminhamentoExternoEspecializadoModel>,
  encaminhamentoEditado?: EncaminhamentoExternoEspecializadoModel
): ValidatorFunction<EncaminhamentoExternoEspecializadoModel> {
  return createValidator<EncaminhamentoExternoEspecializadoModel>(
    {
      especialidadeSisreg: [required],
      classificacaoRiscoEncaminhamento: [required],
      motivoEncaminhamento: [richTextMaxLength(1000)],
      observacoes: [richTextMaxLength(300)],
      complemento: [maxLength(100)],
    },
    (values: EncaminhamentoExternoEspecializadoModel, errors: ErrorObject<EncaminhamentoExternoEspecializadoModel>) => {
      if (canAcessoCBORegisterCid10) {
        errors.cidEncaminhamento = required(values.cidEncaminhamento)
      } else {
        errors.ciapEncaminhamento = required(values.ciapEncaminhamento)
      }

      encaminhamentosRecentes?.forEach((encaminhamentoSalvo) => {
        if (encaminhamentoEditado !== encaminhamentoSalvo) {
          const hipoteseDiagnosticoSalva = canAcessoCBORegisterCid10
            ? encaminhamentoSalvo.cidEncaminhamento?.codigo
            : encaminhamentoSalvo.ciapEncaminhamento?.codigo

          const hipoteseDiagnosticoInformada = canAcessoCBORegisterCid10
            ? values.cidEncaminhamento?.codigo
            : values.ciapEncaminhamento?.codigo

          if (
            encaminhamentoSalvo.especialidadeSisreg?.id === values.especialidadeSisreg?.id &&
            hipoteseDiagnosticoSalva === hipoteseDiagnosticoInformada
          ) {
            errors[FORM_ERROR] = canAcessoCBORegisterCid10
              ? 'Já existe um encaminhamento cadastrado para esta Especialidade e Hipótese / Diagnóstico (CID10).'
              : 'Já existe um encaminhamento cadastrado para esta Especialidade e Hipótese / Diagnóstico (CIAP2).'
          }
        }
      })

      return errors
    }
  )
}
